import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { ChevronDownIcon } from 'lucide-react';

const LanguageSwitcher = () => {
  const { currentLanguage, changeLanguage, getCurrentLanguageInfo, getAvailableLanguages, isRTL } = useLanguage();
  const [isOpen, setIsOpen] = React.useState(false);

  const currentLang = getCurrentLanguageInfo();
  const availableLanguages = getAvailableLanguages();

  const handleLanguageChange = (languageCode) => {
    changeLanguage(languageCode);
    setIsOpen(false);
  };

  return (
    <div className="relative z-[100]">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 shadow-sm transition-colors ${isRTL ? 'flex-row-reverse' : ''}`}
      >
        <span className="text-lg">{currentLang.flag}</span>
        <span>{currentLang.name}</span>
        <ChevronDownIcon className="h-4 w-4 shrink-0" />
      </button>

      {isOpen && (
        <div className="absolute end-0 top-full z-[200] mt-2 w-48 min-w-[12rem] rounded-xl border border-slate-200 bg-white py-1 shadow-lg ring-1 ring-black/5">
          {availableLanguages.map((lang) => (
            <button
              key={lang.code}
              type="button"
              onClick={() => handleLanguageChange(lang.code)}
              className={`flex w-full items-center gap-2 px-4 py-3 text-sm transition-colors hover:bg-slate-100 ${isRTL ? 'flex-row-reverse text-right' : 'text-left'} ${
                currentLanguage === lang.code ? 'bg-sky-50 font-semibold text-sky-800' : 'text-slate-700'
              }`}
            >
              <span className="text-lg">{lang.flag}</span>
              <span className="min-w-0 flex-1">{lang.name}</span>
              {currentLanguage === lang.code && <span className="shrink-0 font-bold text-sky-600">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
